/****************************************************************************************
 * File Name    : PatrolHistoryList.vue
 * Function     : 개정 이력 관리 목록 페이지
 * Author       : 최명호
 * Tester       :
 * Page         :
 * Target       :
 * Description  : 개정 이력을 목록 형태로 표시하고 관리하는 페이지
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2021.04.16  	최명호    	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title = "개정 이력 등록현황" />
                </div>
            </a-col>
        </a-row>
        <a-form class="" layout = "vertical" >
            <a-card style="text-align:right;">
                <a-space align="end">
                    <div>
                        <a-button type="primary" icon="plus-circle" size = "default" @click="goToCreate()">
                            등록하기
                        </a-button>
                    </div>
                </a-space>
                <p/>
                <a-table :columns="columns" size = "small" :bordered=false :data-source="data" :pagination="true" :scroll="{ x: 0, y: '80vh' }">
                    <span slot="content" slot-scope="text">
                        <span>{{ text }}</span>
                    </span>
                    <span slot="image" slot-scope="record">
                        <div v-if="record">
                            <img :src="getImageUrl(record)" 
                                 style="height: 20px; max-width: 150px; object-fit: contain;"
                                 @click="showImage(record)" />
                        </div>
                        <span v-else>-</span>
                    </span>
                    <span slot="date" slot-scope="text">
                        <span>{{ formatToKoreanDate(text) }}</span>
                    </span>
                    <span slot="action" slot-scope="record">
                        <span class="not-mobile" style = 'cursor:pointer' @click="handleEdit(record.seq)">
                            <a-icon type="edit" /> Edit
                        </span>
                        <a-divider class="not-mobile" type="vertical" />
                        <span class="not-mobile" style = 'cursor:pointer' @click="handleDelete(record.seq)">
                            <a-icon type="delete" /> Delete
                        </span>
                    </span>
                </a-table>
            </a-card>
        </a-form>
        
        <!-- 이미지 확대 모달 -->
        <a-modal
            :visible="imageModalVisible"
            :footer="null"
            @cancel="closeImageModal"
            width="80%"
            centered
        >
            <img :src="largeImageUrl" style="width: 100%" />
        </a-modal>
    </div>
</template>
<script>
import PageHeader from "../components/PageHeader.vue";

export default {
    name: 'PatrolHistoryList',
    components: {
        PageHeader
    },
    data() {
        return {
            data: [],
            columns: [
                { title: '변경내용', dataIndex: 'content', key: 'content', scopedSlots: { customRender: 'content' }},
                { title: '참고사진', dataIndex: 'uploadFileSeqList', key: 'image', scopedSlots: { customRender: 'image' }},
                { title: '적용일자', dataIndex: 'applyDate', key: 'date', scopedSlots: { customRender: 'date' }},
                { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 180 }
            ],
            productCsSeq: this.$route.params.productCsSeq,
            imageModalVisible: false,
            largeImageUrl: '',
            fileDelimiter: '||',
        };
    },
    mounted() {
        this.fetchHistoryList();
    },
    methods: {
        // 개정 이력 목록 조회
        fetchHistoryList() {
            const url = this.$store.state.nodeApiUrl + '/product/patrol_history_list';
            
            // productCsSeq 기준으로 필터링하는 쿼리 파라미터 추가
            this.$http.get(`${url}?product_cs_seq=${this.productCsSeq}`)
                .then((response) => {
                    if (response.status === 200) {
                        // 응답 데이터를 목록에 저장
                        const historyItems = response.data;
                        
                        // 테이블 데이터 형식으로 변환
                        this.data = historyItems.map((item, index) => {
                            // 서버에서 온 uploadFileSeqList가 null이면 빈 문자열로 초기화
                            const uploadFileList = item.UPLOAD_FILE_SEQ_LIST || '';
                            
                            return {
                                key: index,
                                seq: item.SEQ,
                                content: item.CONTENT,
                                applyDate: item.APPLY_DATE,
                                uploadFileSeqList: uploadFileList,
                                created: item.CREATED,
                                updated: item.UPDATED
                            };
                        });
                    }
                })
                .catch((error) => {
                    console.error('이력 목록 조회 실패:', error);
                    this.$message.error('이력 목록을 가져오는 중 오류가 발생했습니다.');
                });
        },
        
        // 이미지 URL 생성
        getImageUrl(seq) {
            if (!seq) return '';
            return `${this.$store.state.hostInService}/upload/image/download/${seq}`;
        },
        
        // 이미지 확대 보기
        showImage(seq) {
            this.largeImageUrl = this.getImageUrl(seq);
            this.imageModalVisible = true;
        },
        
        // 이미지 모달 닫기
        closeImageModal() {
            this.imageModalVisible = false;
        },
        
        // 수정 페이지로 이동
        handleEdit(seq) {
            this.$router.push({
                path: '/patrolHistoryCreate',
                query: { 
                    seq: seq,
                    productCsSeq: this.productCsSeq
                }
            });
        },
        
        // 삭제 함수
        handleDelete(seq) {
            if (confirm('정말 삭제하시겠습니까?')) {
                const url = `${this.$store.state.nodeApiUrl}/product/patrol_history_delete/${seq}`;
                this.$http.delete(url)
                    .then((response) => {
                        if (response.status === 200) {
                            this.$message.success('성공적으로 삭제되었습니다.');
                            this.fetchHistoryList(); // 목록 다시 로드
                        }
                    })
                    .catch((error) => {
                        console.error('삭제 중 오류 발생:', error);
                        this.$message.error('삭제 중 오류가 발생했습니다.');
                    });
            }
        },
        
        // 등록 페이지로 이동
        goToCreate() {
            // 현재 제품 CS SEQ를 쿼리 파라미터로 전달
            this.$router.push({
                path: '/patrolHistoryCreate',
                query: { productCsSeq: this.productCsSeq }
            });
        },
        
        // 날짜를 한국 시간(GMT+9)으로 변환하여 YYYY-MM-DD 형식으로 반환
        formatToKoreanDate(dateString) {
            if (!dateString) return '';
            
            // GMT 시간을 Date 객체로 변환
            const date = new Date(dateString);
            
            // GMT+9 시간으로 변환 (9시간 추가)
            const koreanDate = new Date(date.getTime() + (9 * 60 * 60 * 1000));
            
            // YYYY-MM-DD 형식으로 포맷팅
            const year = koreanDate.getUTCFullYear();
            const month = String(koreanDate.getUTCMonth() + 1).padStart(2, '0');
            const day = String(koreanDate.getUTCDate()).padStart(2, '0');
            
            return `${year}-${month}-${day}`;
        }
    }
}
</script>
<style scoped>
@media (max-width: 1280px) {
    .not-mobile {
        display: none !important;
    }
}
</style> 